
var componentMixin={
  props: ["modelValue"],
  data: ()=>({
    componentValue: "",
  }),
  watch: {
    modelValue: {
      handler() {
        this.componentValue=this.modelValue;
      }, immediate: true,
    },
    componentValue: {
      handler () {
        if (JSON.stringify(this.componentValue)!=JSON.stringify(this.modelValue))
          this.$emit("update:modelValue", this.componentValue);
      },
    }
  },
}

export { componentMixin }
